<template>
  <div class="certificatePrintManage">
    <el-card>
      <el-form :inline="true" :model="filter" class="demo-form-inline" size="small">
        <el-form-item label="所属代理商" v-if="checkAdmin()">
          <el-select v-model="filter.companyId" placeholder="请选择所属项目">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请人">
          <el-input v-model="filter.applyUserName" placeholder="请输入申请人名称"></el-input>
        </el-form-item>
        <el-form-item label="审核人">
          <el-input v-model="filter.auditUserName" placeholder="请输入审核人名称"></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="filter.auditState" placeholder="请选择发放状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="待审核" value="1"></el-option>
            <el-option label="已通过" value="2"></el-option>
            <el-option label="已驳回" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker
            v-model="dateList"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="审核时间">
          <el-date-picker
            v-model="dateList1"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" style="margin-left: 20px" @click="search">查询</el-button>
          <el-button type="" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px">
      <el-button v-if="!checkAdmin()" type="primary" size="small" @click="showProp(1)">未套打证书申请</el-button>
      <el-button v-if="!checkAdmin()" type="primary" size="small" style="margin-left: 10px" @click="showProp(2)">补打证书申请</el-button>
      <el-button v-if="checkAdmin()" type="primary" size="small" style="margin-left: 10px" @click="printApplyAudit">批量审核</el-button>
      <el-table :data="list" border style="margin-top: 10px" @selection-change="handleSelectionChange">
        <el-table-column v-if="checkAdmin()" type="selection" width="55" :selectable="selectable"></el-table-column>
        <el-table-column align="center" label="所属代理商" prop="companyName" width="" key="companyName"></el-table-column>
        <el-table-column align="center" label="申请时间" prop="applyTime" width="160" key="applyTime"></el-table-column>
        <el-table-column align="center" label="申请人" prop="applyUserName" width="" key="applyUserName"></el-table-column>
        <el-table-column align="center" label="申请说明" prop="applyExplain" width="" key="applyExplain">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" popper-class="tooltip" placement="top">
              <div slot="content" class="tooltip">{{ scope.row.applyType === 1 ? scope.row.applyExplain : scope.row.repairPrintExplain }}</div>
              <div style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;">{{ scope.row.applyType === 1 ? scope.row.applyExplain : scope.row.repairPrintExplain }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" label="申请类型" prop="applyType" width="" key="applyType">
          <template slot-scope="scope">
            {{ scope.row.applyType === 1 ? '套打' : '补打' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="审核状态" prop="auditState" width="" key="auditState">
          <template slot-scope="scope">
            <span v-if="scope.row.auditState === 1">待审核</span>
            <span v-if="scope.row.auditState === 2">已通过</span>
            <span v-if="scope.row.auditState === 3">已驳回</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="审核时间" prop="auditTime" width="" key="auditTime"></el-table-column>
        <el-table-column align="center" label="审核人" prop="auditUserName" width="" key="auditUserName"></el-table-column>
        <el-table-column align="center" label="驳回原因" prop="rejectReason" width="" key="rejectReason"></el-table-column>
        <el-table-column align="center" label="操作" prop="" width="">
          <template slot-scope="scope">
            <a v-if="checkAdmin() && scope.row.auditState === 1" href="javascript:;" @click="audit(scope.row)">审核</a>
            <a v-if="!checkAdmin() && scope.row.auditState === 3" href="javascript:;" @click="showProp(scope.row.applyType)">重新申请</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <PrintApply ref="PrintApply" />
    <PrintAudit ref="PrintAudit" />
    <AuditRejected ref="AuditRejected" @close="close" />
  </div>
</template>

<script>
import { getCompanyByPid, getListPagePrint, getListPageByAgentPrint, judgeApply, printApplyAudit } from "@/api/certificate/index";
import PrintApply from '../components/PrintApply.vue'
import PrintAudit from '../components/PrintAudit.vue'
import AuditRejected from '../components/AuditRejected.vue'
export default {
  name: 'CertificatePrintManage',
  components: { PrintApply, PrintAudit, AuditRejected },
  data () {
    return {
      companyList: [],
      filter: {
        page: 1,
        limit: 10,
        companyId: '',
        applyUserName: '',
        auditUserName: '',
        auditState: '',
        applyStartDate: '',
        applyEndDate: '',
        auditStartDate: '',
        auditEndDate: ''
      },
      list: [],
      total: 0,
      ids: '',
      // 驳回原因 
      rejectReason: ''
    }
  },
  computed: {
    dateList: {
      get() {
        return [this.filter.applyStartDate, this.filter.applyEndDate]
      },
      set(v) {
        if (v && v.length) {
          this.filter.applyStartDate = v[0] + ' 00:00:00' || ''
          this.filter.applyEndDate = v[1] + ' 23:59:59' || ''
        } else {
          this.filter.applyStartDate = ''
          this.filter.applyEndDate = ''
        }
      }
    },
    dateList1: {
      get() {
        return [this.filter.auditStartDate, this.filter.auditEndDate]
      },
      set(v) {
        if (v && v.length) {
          this.filter.auditStartDate = v[0] + ' 00:00:00' || ''
          this.filter.auditEndDate = v[1] + ' 23:59:59' || ''
        } else {
          this.filter.auditStartDate = ''
          this.filter.auditEndDate = ''
        }
      }
    }
  },
  created() {
    if (this.checkAdmin()) {
      this.getCompanyByPid()
    }
    this.getList()
  },
  methods: {
    async getCompanyByPid() {
      const res = await getCompanyByPid({id: 1})
      this.companyList = res.data
    },
    async getList() {
      let res
      if (this.checkAdmin()) {
        res = await getListPagePrint(this.filter)
      } else {
        res = await getListPageByAgentPrint(this.filter)
      }
      this.list = res.data.records
      this.total = +res.data.total
    },
    async showProp(type) {
      const res = await judgeApply()
      if (res.code === 1000) {
        return this.$message.error('当前已有证书套打申请待审核。')
      }
      this.$refs.PrintApply.init(type)
    },
    handleSelectionChange(v) {
      this.ids = v.map(item => item.id)
    },
    close(rejectReason) {
      this.rejectReason = rejectReason
      this.audit1(3)
    },
    printApplyAudit() {
      if (!this.ids.length) {
        return this.$message.error('请选择审核数据')
      }
      this.$confirm('请选择', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '审核通过',
        cancelButtonText: '审核驳回',
        type: 'warning'
      }).then(() => {
        this.audit1(2)
      }).catch((action) => {
        if (action === 'cancel') {
          this.$refs.AuditRejected.init()
        }
      });
    },
    async audit1(auditState) {
      const res = printApplyAudit({ ids: this.ids.join(), auditState, rejectReason: this.rejectReason })
      this.$message.success('操作成功')
      this.search()
    },
    selectable(v) {
      return v.auditState === 1
    },
    audit(row) {
      this.$refs.PrintAudit.init(row)
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = ''
      })
      this.filter.page = 1
      this.filter.limit = 10
      this.getList()
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.certificatePrintManage {

}
.tooltip {
  width: 500px !important;
}
</style>
